import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { PageResponse } from '@/core/api/sicom-api/sistema/usuario/usuario.model';
import { FuncionarioItemResponse, FuncionarioRequest, FuncionarioResponse } from './funcionario.model';

/**
 * Cadastro de funcionário (Configurações → Registro → Funcionários).
 *
 * <b>Não tem `excluir`</b>: não existe exclusão de funcionário. Quem sai da instituição recebe
 * `dtAfastamento`, campo do próprio cadastro.
 */
@Injectable({ providedIn: 'root' })
export class FuncionarioService extends BaseService {
    private readonly BASE = environment.basePath + '/sistema/registro/funcionarios';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista paginada no servidor. Filtra por nome, CPF ou matrícula e, opcionalmente, por UF. */
    listar(params: { q?: string; uf?: string; page?: number; size?: number }): Observable<PageResponse<FuncionarioItemResponse>> {
        let httpParams = new HttpParams();
        if (params.q) httpParams = httpParams.set('q', params.q);
        if (params.uf) httpParams = httpParams.set('uf', params.uf);
        httpParams = httpParams.set('page', params.page ?? 0);
        httpParams = httpParams.set('size', params.size ?? 20);
        return this.http.get<PageResponse<FuncionarioItemResponse>>(this.BASE, { params: httpParams });
    }

    buscarPorChave(uf: string, idSolicitante: number): Observable<FuncionarioResponse> {
        return this.http.get<FuncionarioResponse>(`${this.BASE}/${uf}/${idSolicitante}`);
    }

    criar(request: FuncionarioRequest): Observable<FuncionarioResponse> {
        return this.http.post<FuncionarioResponse>(this.BASE, request);
    }

    editar(uf: string, idSolicitante: number, request: FuncionarioRequest): Observable<FuncionarioResponse> {
        return this.http.put<FuncionarioResponse>(`${this.BASE}/${uf}/${idSolicitante}`, request);
    }

    /**
     * Atribui/remove o Agente de Registro pela chave do funcionário — fora do salvamento do
     * cadastro, porque a role é outra (`configuracoes.usuarios.editar-agr`). 422 quando não há
     * cadastro de funcionário para a chave.
     */
    alterarAgenteAgr(uf: string, idSolicitante: number, agenteAgr: boolean): Observable<void> {
        return this.http.put<void>(`${this.BASE}/${uf}/${idSolicitante}/agente-agr`, { agenteAgr });
    }
}
